<gp-icon [attr.icon]="icon"></gp-icon>
